import React from 'react'

function SizeShow({ height,width,booth_dimension_unit }) {
  return height && width && booth_dimension_unit
    ? `${height}${booth_dimension_unit === "feet" ? " ft" : " m"} × ${width}${booth_dimension_unit === "feet" ? " ft" : " m"}`
    : "-";
}

export default SizeShow